const className = 'region';

const isAvailable = ({region}) => Boolean(region);

const getProps = ({region}) => region;

export default {className, isAvailable, getProps};
